import {
    SET_EDITED_PROFILE,
    SET_LOGIN_INFO,
    SET_PLACE_INFO,
  SET_PAYMENT_TYPE,
} from "./ActionTypes";
import logger from "components/Logger"
import { ILoginData } from "../types/Login";
import { IPlaceData } from "../types/Place";
import { IPaymentType } from "../types/Payment";

const initialState = {
    loginInfo: JSON.parse(String(localStorage.getItem('loginInfo'))) || undefined,
    placeInfo: JSON.parse(String(localStorage.getItem('placeInfo'))) || undefined,
    paymentInfo:{ payment_type: null, paymentTypeInfo: undefined}
}

interface ICardapioAppState {
    loginInfo: ILoginData | undefined;
    placeInfo: IPlaceData | undefined;
    paymentInfo: { payment_type: number | null, paymentTypeInfo: IPaymentType | undefined}
}

const rootReducer = (state = initialState, action: any): any => {
    switch (action.type) {
        case SET_LOGIN_INFO: {
            return {
                ...state,
                loginInfo: action.payload
            }
        }
        case SET_PLACE_INFO: {
            return {
                ...state,
                placeInfo: action.payload
            }
        }
        case SET_EDITED_PROFILE: {
            return {
                ...state,
                loginInfo: action.payload
            }
        }
        case SET_PAYMENT_TYPE: {
                return {
                    ...state,
                    paymentInfo: action.payload
                }
        }
        default: return state
    }
}

export type { ICardapioAppState }
export default rootReducer
